import { formatPrice } from '@utils/numberFormatter';
import styles from './ComparisonVariantDetails.module.scss'; // Style as needed
import { cn } from '@utils/utils';

export interface FeatureItem {
    name: string;
    description: string;
    value: string;
}

export interface CarVariant {
    variantName: string;
    fuelType: string;
    engine: string;
    emission: string;
    transmission: string;
    slug: string;
    marketPrice: number | null;
    adspPrice: number;
    ackoDriveSavings: number;
    exShowRoomPrice: number;
    onRoadPrice: number;
    featureItemDtos: FeatureItem[];
    mileage: number | null;
}

interface VariantCardProps {
    variant: CarVariant;
    isSelected: boolean;
}



const ComparisonVariantDetails = ({ variant, isSelected }: VariantCardProps) => {
    const transmission = variant.featureItemDtos.find(f => f.name === "Transmission Type")?.value || variant.transmission;
    const mileage = variant.featureItemDtos.find(f => f.name === "ARAI Mileage")?.value;
    const price = variant.onRoadPrice;

    return (
        <div className={cn(styles.card, isSelected && styles.selected)}>
            <div className={styles.topRow}>
                <span className={styles.variantName}>{variant.variantName}</span>
                <span className={styles.price}>{formatPrice(price)}</span>
            </div>
            <div className={styles.bottomRow}>
                <span>{variant.fuelType}</span>
                {transmission && <span>• {transmission}</span>}
                {mileage && <span>• {mileage} kmpl</span>}
            </div>
        </div>
    );
};

export default ComparisonVariantDetails;
